import { IntakeDetails } from '@/features/regulatory-intake/intake-details/components';

const RegulatoryIntakeDetailsPage = () => {
  return <IntakeDetails />;
};

export default RegulatoryIntakeDetailsPage;
